import { render, staticRenderFns } from "./MaritalStatus.vue?vue&type=template&id=d608b33a"
import script from "./MaritalStatus.vue?vue&type=script&lang=js"
export * from "./MaritalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports